export class NonNativePlatformGeolocationError extends Error {
  constructor() {
    super("Failed to fetch current location due to the device not being native (iOS/Android).");
  }
}
